import axios from 'lib/axios';

import {
  STRATA_ERROR,
  STRATAS_ERROR,
  STRATA_LOADING,
  STRATA_RECEIVED,
  STRATAS_LOADING,
  STRATAS_RECEIVED
} from 'constants/actions';

import {
  E_STRATA_UNKNOWN,
  E_STRATAS_UNKNOWN,
  E_STRATA_NOT_FOUND,
  E_STRATAS_NOT_FOUND
} from 'constants/errors';

import { dispatcher } from 'lib/redux';

export const fetchStratas = (opts) => async () => {
  dispatcher(STRATAS_LOADING, true);
  var params = { state: opts.state || 'SA' }

  if (opts.includeOther) {
    params.includeOther = true
  }

  try {
    var response = await axios.get('stratas', { params: params });

    dispatcher(STRATAS_LOADING, false);
    dispatcher(STRATAS_RECEIVED, response.data);
  } catch (e) {
    dispatcher(STRATAS_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.status === 404) {
      return dispatcher(STRATAS_ERROR, E_STRATAS_NOT_FOUND);
    }

    dispatcher(STRATAS_ERROR, E_STRATAS_UNKNOWN);
  }
};

export const fetchStrata = (strataId) => async () => {
  dispatcher(STRATA_LOADING, true);

  try {
    var response = await axios.get(`stratas/${strataId}`);

    dispatcher(STRATA_LOADING, false);
    dispatcher(STRATA_RECEIVED, response.data);
  } catch (e) {
    dispatcher(STRATA_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.status === 404) {
      return dispatcher(STRATA_ERROR, E_STRATA_NOT_FOUND);
    }

    dispatcher(STRATA_ERROR, E_STRATA_UNKNOWN);
  }
};
